import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Briefcase, Wrench, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import AnimatedSection from '../components/AnimatedSection';
import { useI18n } from '../i18n/I18nContext';

function NotFoundPage() {
  const { t, localizedPath } = useI18n();

  return (
    <>
      <SEO title={t.notFound.title} description={t.notFound.metaDescription} />
      <div className="min-h-[70vh] flex items-center justify-center px-4 py-20">
        <div className="max-w-xl mx-auto text-center">
          <AnimatedSection animation="scale-in">
            <p className="text-8xl sm:text-9xl font-bold text-[#FDCB12] leading-none mb-4">404</p>
          </AnimatedSection>
          <AnimatedSection animation="fade-in-up" delay={100}>
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">{t.notFound.heading}</h1>
          </AnimatedSection>
          <AnimatedSection animation="fade-in-up" delay={200}>
            <p className="text-gray-400 mb-10">
              {t.notFound.text}
            </p>
          </AnimatedSection>
          <AnimatedSection animation="fade-in-up" delay={300}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
              <Link
                to={localizedPath('/')}
                className="button-shine inline-flex items-center justify-center gap-2 bg-[#FDCB12] text-black px-6 py-3 rounded-md font-semibold hover:bg-[#FF5500] hover:text-white transition-all duration-300"
              >
                <Home className="h-5 w-5" />
                {t.notFound.backHome}
              </Link>
              <Link
                to={localizedPath('/#contact')}
                className="inline-flex items-center justify-center gap-2 border-2 border-[#FDCB12] text-[#FDCB12] px-6 py-3 rounded-md font-semibold hover:bg-[#FDCB12] hover:text-black transition-all duration-300"
              >
                {t.notFound.contactUs}
                <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </AnimatedSection>
          <AnimatedSection animation="fade-in-up" delay={400}>
            <div className="grid grid-cols-2 gap-4 max-w-md mx-auto">
              <Link
                to={localizedPath('/portfolio')}
                className="flex flex-col items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-lg p-5 hover:border-[#FDCB12] transition-all duration-300 hover:-translate-y-1"
              >
                <Briefcase className="h-7 w-7 text-[#FDCB12]" />
                <span className="text-sm font-medium text-white">{t.notFound.portfolio}</span>
              </Link>
              <Link
                to={localizedPath('/#services')}
                className="flex flex-col items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-lg p-5 hover:border-[#FDCB12] transition-all duration-300 hover:-translate-y-1"
              >
                <Wrench className="h-7 w-7 text-[#FDCB12]" />
                <span className="text-sm font-medium text-white">{t.notFound.services}</span>
              </Link>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </>
  );
}

export default NotFoundPage;
